import { useMediaQuery } from "./useMedia";

export function isDesktop() {
    return useMediaQuery('(min-width: 84.375em)');
}